export const FINANCIAL_DATA_BY_ID = (id) => `v2/financial/annual-budgets/${id}`;
export const FINANCIAL_DATA = "v2/financial/annual-budgets";
export const FINANCIAL_GRANT_BY_ID = (id) => `v2/financial-grants/${id}`;
export const INTERNATIONAL_DONATIONS_BY_ID = (id) => `v2/international-donations/${id}`;
